export const ROUTES = {
  LOGIN: "/login",
  REGISTER: "/register",
  FORGOT_PASSWORDS: "/forgot-password",
  RESET_EMAIL: "/reset-password",
  LEGALITIES_POLICY: "/legalities-policy",
  ENTER_CODE: "/enter-code",
  DISCOVER: "/",
  DISCOVER_DETAIL: "/discover/:id",
  BEST_SELLING_COURSE: "/best-selling-course",
  BEST_SELLING_HANDOUT: "/best-selling-handout",
  MY_LEARNING: "/my-learning",
  LEARNING_LOG: "/learning-log",
  PAYMENT_MANAGEMENT: "/payments",
  PAYMENT_MANAGEMENT_RECIPT: "/payments/:userType",
  SETTINGS: "/settings",
  BECOME_CONTENT_CREATOR: "/content-creator",
  MY_CONTENT: "/my-content",
  CREATE_HANDOUT: "/create-content/handout",
  CREATE_COURSE: "/create-content/course",
  MY_EARNINGS: "/my-earnings",
  ADMIN: "/admin",
  USERS: "/manage-users",
  USERS_USER_PERSONAL_INFO: "/manage-users/:userType/:user_id",
  // "/manage-user-personal-info-content-creator",
  USERS_USER_PERSONAL_INFOMATION: "/admin/:userType/:user_id",
  // "/manage-user-personal-info-standard-user",
  CONTENTS: "/contents",
  CONTENTS_EDIT: "/contents/edit/:id",
  PENDING_REFUND: "/pending-refunds",
  PENDING_VERIFICATION: "/pending-verifications",
  PROFILE_VIEW: "/profile-view/:userId",
  CART: "/cart",
  CHECKOUT: "/checkout",
  REVIEW_EDUCATION_CONTENT: "/review-education-content/:id",
  EDUCATION_HANDOUT_OVERVIEW: "/education-content-handout/:id",
  EDUCATION_CONTENT_COURSE: "/education-content-course/:id",
  View_CONTENT_STRUCTURE: "/view-content-structure/:id",
};

export default ROUTES;
